import { Trans } from '@lingui/react/macro'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'
import Grid from '@mui/material/Grid'
import Avatar from '@mui/material/Avatar'

const steps = [
  { num: 1, title: <Trans>Create your account</Trans>, desc: <Trans>Register with your email address and personal information to access the platform.</Trans> },
  {
    num: 2,
    title: <Trans>Find your practitioner</Trans>,
    desc: <Trans>Use the meeting link provided by your healthcare professional, or search for a practitioner by specialty or location.</Trans>,
  },
  {
    num: 3,
    title: <Trans>Book an appointment</Trans>,
    desc: <Trans>Select an available time slot, fill in your medical information, and confirm your booking.</Trans>,
  },
  {
    num: 4,
    title: <Trans>Join the teleconsultation</Trans>,
    desc: <Trans>At the scheduled time, go to your consultations and join the waiting room. Make sure your camera and microphone are enabled.</Trans>,
  },
  {
    num: 5,
    title: <Trans>Access your documents</Trans>,
    desc: <Trans>After the consultation, find your medical documents, prescriptions, and reports in the Documents section of your account.</Trans>,
  },
]

const avatarSx = {
  width: 28,
  height: 28,
  fontSize: 12,
  fontWeight: 700,
  backgroundColor: 'primary.main',
  mb: 1,
}

const paperSx = {
  p: 2,
  borderRadius: 3,
  bgcolor: 'grey.50',
  height: '100%',
  transition: 'box-shadow 0.2s',
  '&:hover': { boxShadow: 3 },
}

export function GettingStartedSection() {
  return (
    <Box>
      <Typography variant="h6" fontWeight={700} sx={{ mb: 0.5 }}>
        <Trans>Getting started</Trans>
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        <Trans>Follow these 5 simple steps for your first appointment.</Trans>
      </Typography>
      <Grid container spacing={1.5}>
        {steps.map((step) => (
          <Grid item xs={6} sm={4} md key={step.num}>
            <Paper elevation={0} sx={paperSx}>
              <Avatar sx={avatarSx}>{step.num}</Avatar>
              <Typography variant="caption" fontWeight={700} display="block" sx={{ mb: 0.5, lineHeight: 1.3 }}>
                {step.title}
              </Typography>
              <Typography variant="caption" color="text.secondary" display="block" sx={{ lineHeight: 1.4 }}>
                {step.desc}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}
